module.exports = __webpack_public_path__ + "media/src/images/abouts/items/online/dtv_1month-cc12284a2c8b59905fedc38fcd997482.jpg";